import React from 'react';
import Modal from '../common/Modal';
import { useLanguage } from '../../contexts/LanguageContext';
import './PushPermissionModal.scss';

const PushPermissionModal = ({
  isOpen,
  onClose,
  onAccept,
  onDecline,
  loading = false
}) => {
  const { t } = useLanguage();

  const handleAccept = async () => {
    try {
      await onAccept();
    } catch (error) {
      console.error('Permission request failed:', error);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onDecline}
      title={t('pushNotifications.enableNotificationsTitle')}
      size="medium"
      closeOnOverlayClick={false}
      showCloseButton={false}
    >
      <div className="push-permission-modal">
        <div className="push-permission-modal__icon">
          🔔
        </div>

        <div className="push-permission-modal__content">
          <p className="push-permission-modal__description">
            {t('pushNotifications.enableNotificationsDescription')}
          </p>

          <ul className="push-permission-modal__benefits">
            <li>{t('pushNotifications.benefit1')}</li>
            <li>{t('pushNotifications.benefit2')}</li>
            <li>{t('pushNotifications.benefit3')}</li>
          </ul>

          <p className="push-permission-modal__note">
            {t('pushNotifications.permissionNote')}
          </p>
        </div>

        <div className="push-permission-modal__actions">
          <button
            className="btn btn-secondary"
            onClick={onDecline}
            disabled={loading}
          >
            {t('common.notNow')}
          </button>
          <button
            className="btn btn-primary"
            onClick={handleAccept}
            disabled={loading}
          >
            {loading ? t('common.loading') : t('pushNotifications.enableNotifications')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PushPermissionModal;
